import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, TrendingUp } from 'lucide-react';
interface ForBrandsProps {
  onCtaClick?: () => void;
}
const benefits = ['Find the right organizers instantly', 'Reduce wasted sponsorship spend', 'Data-backed decisions', 'Measurable outcomes'];
export function ForBrands({
  onCtaClick
}: ForBrandsProps) {
  return <section id="brands" className="py-24 bg-slate-900" data-id="element-683">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-684">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-685">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-686">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-cyan-950/30 text-cyan-400 text-sm font-medium mb-6 border border-cyan-900/50" data-id="element-687">
              <TrendingUp size={16} data-id="element-688" /> For Brands
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-689">
              Smarter sponsorship investments.
            </h2>
            <p className="text-xl text-slate-400 mb-8" data-id="element-690">
              "Sponsorships that feel natural — not forced."
            </p>

            <ul className="space-y-4 mb-10" data-id="element-691">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="flex items-center text-slate-300" data-id="element-692">
                  <CheckCircle2 className="text-cyan-500 mr-3 flex-shrink-0" size={20} data-id="element-693" />
                  {benefit}
                </motion.li>)}
            </ul>

            <button onClick={onCtaClick} className="px-8 py-4 bg-white text-slate-900 hover:bg-slate-200 rounded-full font-bold transition-colors" data-id="element-694">
              Start as a Brand
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative" data-id="element-695">
            <div className="absolute inset-0 bg-cyan-500/20 blur-3xl rounded-full opacity-30" data-id="element-696"></div>
            <div className="relative bg-slate-800 border border-slate-700 rounded-2xl p-8 shadow-2xl" data-id="element-697">
              {/* Mock UI Card */}
              <div className="flex items-center justify-between mb-6 border-b border-slate-700 pb-4" data-id="element-698">
                <div className="flex items-center gap-3" data-id="element-699">
                  <div className="w-10 h-10 bg-slate-700 rounded-full" data-id="element-700"></div>
                  <div data-id="element-701">
                    <div className="h-4 w-32 bg-slate-600 rounded mb-2" data-id="element-702"></div>
                    <div className="h-3 w-20 bg-slate-700 rounded" data-id="element-703"></div>
                  </div>
                </div>
                <div className="px-3 py-1 bg-green-500/20 text-green-400 text-xs rounded-full" data-id="element-704">
                  98% Match
                </div>
              </div>
              <div className="space-y-3" data-id="element-705">
                <div className="h-3 w-full bg-slate-700 rounded" data-id="element-706"></div>
                <div className="h-3 w-5/6 bg-slate-700 rounded" data-id="element-707"></div>
                <div className="h-3 w-4/6 bg-slate-700 rounded" data-id="element-708"></div>
              </div>
              <div className="mt-6 flex gap-3" data-id="element-709">
                <div className="h-8 w-24 bg-cyan-600 rounded-md" data-id="element-710"></div>
                <div className="h-8 w-24 bg-slate-700 rounded-md" data-id="element-711"></div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}